<template>
  <div>
    <v-row>
      <v-col
        cols="12"
        md="4"
      >
        <v-text-field
          v-model="billing.billItemFontSize"
          label="Bill Item Font Size"
          type="number"
          placeholder="11px default"
          max="50"
          min="5"
          :error-messages="errors.getMessage('billItemFontSize')"
        />
      </v-col>
      <v-col
        cols="12"
        md="4"
      >
        <v-text-field
          v-model="billing.billItemQtyFontSize"
          label="Bill Item Qty Font Size"
          placeholder="11px default"
          type="number"
          max="50"
          min="5"
          :error-messages="errors.getMessage('billItemQtyFontSize')"
        />
      </v-col>
      <v-col
        cols="12"
        md="4"
      >
        <v-text-field
          v-model="billing.billTermsFontSize"
          label="Terms & Conditions Font Size"
          placeholder="8px default"
          type="number"
          max="20"
          min="5"
          :error-messages="errors.getMessage('billTermsFontSize')"
        />
      </v-col>

      <v-col
        cols="12"
        md="4"
      >
        <v-text-field
          v-model="billing.billDateTimeTransFontSize"
          label="DateTime & Transaction ID Font Size"
          type="number"
          placeholder="11px default"
          max="50"
          min="5"
          :error-messages="errors.getMessage('billDateTimeTransFontSize')"
        />
      </v-col>
      <v-col
        cols="12"
        md="4"
      >
        <v-text-field
          v-model="billing.billHrFontSize"
          label="Horizental dotted line Font Size"
          placeholder="3px default"
          type="number"
          max="11"
          min="1"
          :error-messages="errors.getMessage('billHrFontSize')"
        />
      </v-col>
      <v-col
        cols="12"
        md="4"
      >
        <v-autocomplete
          v-model="billing.billtextFlow"
          :items="flows"
          item-text="name"
          item-value="value"
          label="Content Flow"
        />
      </v-col>
    </v-row>
    <v-row>
      <v-col
        cols="12"
        md="4"
      >
        <v-text-field
          v-model="billing.billLogoWidth"
          label="Logo Width"
          placeholder="70px default"
          :error-messages="errors.getMessage('billLogoWidth')"
        />
      </v-col>
      <v-col
        cols="12"
        md="4"
      >
        <v-text-field
          v-model="billing.billLogoHeight"
          label="Logo Height"
          placeholder="70px default"
          :error-messages="errors.getMessage('billLogoHeight')"
        />
      </v-col>
    </v-row>
    <v-row>
      <v-col
        cols="12"
        md="4"
        sm="6"
      >
        <v-checkbox
          v-model="billing.billLogo"
          label="Display App Logo"
        />
        <v-checkbox
          v-model="billing.billLogoRound"
          label="Logo Corner Round"
        />
        <v-checkbox
          v-model="billing.billAppName"
          label="Display App Name"
        />
      </v-col>
      <v-col
        cols="12"
        md="4"
        sm="6"
      >
        <v-checkbox
          v-model="billing.billAddress"
          label="Display Address"
        />
        <v-checkbox
          v-model="billing.billPhone"
          label="Display Phone"
        />
        <v-checkbox
          v-model="billing.billType"
          label="Display Type"
        />
        <v-checkbox
          v-model="billing.billBarcode"
          label="Display Barcode"
        />
      </v-col>
      <v-col
        cols="12"
        md="4"
        sm="6"
      >
        <v-checkbox
          v-model="billing.billItemUnit"
          label="Display Product Unit"
        />
        <v-checkbox
          v-model="billing.billBy"
          label="Display Biller Name"
        />
        <v-checkbox
          v-model="billing.billDateTime"
          label="Display DateTime"
        />
        <v-checkbox
          v-model="billing.billRefrence"
          label="Display Transaction ID"
        />
      </v-col>
    </v-row>

    <v-row>
      <v-btn
        class="info"
        @click="generalUpdate"
      >
        Update
      </v-btn>
    </v-row>
  </div>
</template>
<script>
import { mapGetters } from "vuex";
export default {
  data() {
    return {
      flows: [
        { name: "Left", value: "text-left" },
        { name: "Center", value: "text-center" },
        { name: "Right", value: "text-right" },
      ],
    };
  },
  computed: {
    ...mapGetters({
      errors: "validation/pull",
      billing: "configs/billing",
    }),
  },

  methods: {
    generalUpdate() {
      Event.$emit("updateConfigs", {
        path: "setting-billing-update",
        payload: this.billing,
      });
    },
  },
};
</script>
